<template>
  <div>
    <v-alert dense border="bottom" type="primary" icon="mdi-information">PRODUCT INFORMATION</v-alert>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <span>Product Group</span>
            <v-radio-group v-model="information.product_group" row>
              <v-radio label="Computing" value="Computing"></v-radio>
              <v-radio label="Printing" value="Printing"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="information.product_line" label="Product Line"></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        v-model="information.BusinessUnit"
                                        label="Business Unit"
                                    ></v-text-field>
          </v-col>-->
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="information.product_no" label="Product No"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              @blur="getKbankToner()"
              v-model="information.product_serial"
              label="Serial No"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="information.product_description" label="Product Description"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["information", "condition"],
  data() {
    return {
      detail: [],
    };
  },
  methods: {
    async getKbankToner() {
      if (
        this.information.project_id == "54" ||
        this.information.project_id == "56"
      ) {
        const url = `${process.env.VUE_APP_ROOT_API}/api/nonhp/search/kbank-printer/${this.information.product_serial}`;
        const { data } = await axios.get(url);
        this.information.site_name = data.branchName;
        this.information.site_address = data.address;
        this.information.site_postcode =
          data.postalcode !== undefined ? data.postalcode : "";
        this.information.customer_name = data.managerName;
        this.information.customer_tel = data.tel;
        this.information.product_group = "Printing";
        this.information.product_line = "Printer";
        this.information.product_no = "Printer HP LaserJet Pro MFP M426m";
        this.information.product_description =
          "Printer HP LaserJet Pro MFP M426m";
        // this.information.remark = `${data.HostName} ${data.macaddress} ${data.IP}`;
        this.information.remark = data.remark;
      }
    },
  },
};
</script>
